module.exports = __webpack_public_path__ + "static/media/quicicon-01.b70a3df8.png";